import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMediaPredicate } from 'react-media-hook';
import { Modal, Checkbox, Button } from 'antd';
import { ERoutesPrivate } from 'common/models/routesModel';
import { useRewardsPopup } from 'common/hooks/RewardsPopup.hooks';
import { MEDIA_MOBILE } from 'common/config/base.config';
import rewardPopupImage from 'app/assets/images/rewardPopupImage.png';
import rewardPopupImageMobile from 'app/assets/images/rewardPopupImageMobile.png';

export const RewardsPopup: React.FC = () => {
  const { isVisible, closePopup } = useRewardsPopup();
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const navigate = useNavigate();

  const isMobile: boolean = useMediaPredicate(MEDIA_MOBILE);

  const handleClose = () => {
    closePopup(dontShowAgain);
  };

  const handleSeeRewards = () => {
    closePopup(dontShowAgain);
    navigate(ERoutesPrivate.Bitecoin);
  };

  return (
    <Modal
      open={isVisible}
      footer={null}
      closable={true}
      closeIcon={<span className="reward-popup__close-icon">✕</span>}
      onCancel={handleClose}
      mask={{ closable: false }}
      width={640}
      centered
      className="reward-popup__modal"
    >
      <div className="reward-popup__banner-wrapper">
        <img
          src={isMobile ? rewardPopupImageMobile : rewardPopupImage}
          alt="Every Bite Counts — Earn Bitecoins Today!"
          className="reward-popup__banner-image"
        />
      </div>

      <div className="reward-popup__body">
        <p className="reward-popup__title">✨ Your MB Go Experience just got more rewarding! ✨</p>
        <p className="reward-popup__description">
          Earn Bitecoins for every purchase you make on MB Go and redeem exciting rewards.
        </p>

        <Checkbox checked={dontShowAgain} onChange={(e) => setDontShowAgain(e.target.checked)} className="reward-popup__checkbox">
          Don&apos;t show again for 30 days
        </Checkbox>

        <Button type="primary" block size="large" onClick={handleSeeRewards} className="btn">
          See rewards
        </Button>
      </div>
    </Modal>
  );
};
